import React from 'react';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const targetId = href.substring(1);
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      const headerHeight = 80;
      const targetPosition = targetElement.offsetTop - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  const quickLinks = [
    { href: '#about', label: 'About Us' },
    { href: '#approach', label: 'Our Approach' },
    { href: '#programs', label: 'Programs' },
    { href: '#learning-kit', label: 'Learning Kit' },
  ];

  const programs = [
    'Playgroup',
    'Nursery',
    'LKG',
    'UKG',
  ];

  const contactInfo = [
    'Phone: +91 7494901888',
    'Email: neev.sps@gmail.com',
    'Mon-Fri: 8:00 AM - 6:00 PM',
  ];

  return (
    <footer className="bg-footer-gradient text-brand-yellow p-16 ">
      <div className="">
        <div className="grid mx-0 lg:grid-cols-2 p-16">
          {/* Brand Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h3 className="text-2xl text-brand-yellow font-bold mb-4">Neev Play School</h3>
            <p className="text-brand-pink text-lg font-semibold mb-4 tracking-wider">
              ROOTED IN VALUES, GROWING WITH LOVE
            </p>
            <p className="text-brand-white leading-relaxed mb-6">
              Nurturing young minds through screen-free, hands-on learning experiences that lay the foundation for lifelong learning.
            </p>
          </motion.div>

          {/* Links Section */}
          <motion.div
            className="grid md:grid-cols-3 gap-16"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-brand-yellow">Quick Links</h4>
              <ul className="space-y-2 text-brand-white">
                {quickLinks.map((link, index) => (
                  <motion.li
                    key={index}
                    initial={{ opacity: 0, x: -10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3, delay: 0.4 + index * 0.1 }}
                    viewport={{ once: true }}
                  >
                    <a
                      href={link.href}
                      onClick={(e) => handleSmoothScroll(e, link.href)}
                      className="text-brand-white hover:text-brand-yellow transition-colors duration-200 font-bold"
                    >
                      {link.label}
                    </a>
                  </motion.li>
                ))}
              </ul>
            </div>

            {/* Programs */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-brand-yellow">Programs</h4>
              <ul className="space-y-2">
                {programs.map((program, index) => (
                  <motion.li
                    key={index}
                    className="text-brand-white"
                    initial={{ opacity: 0, x: -10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3, delay: 0.6 + index * 0.1 }}
                    viewport={{ once: true }}
                  >
                    {program}
                  </motion.li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-brand-yellow">Contact Info</h4>
              <ul className="space-y-2">
                {contactInfo.map((info, index) => (
                  <motion.li
                    key={index}
                    className="text-brand-white"
                    initial={{ opacity: 0, x: -10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3, delay: 0.8 + index * 0.1 }}
                    viewport={{ once: true }}
                  >
                    {info}
                  </motion.li>
                ))}
              </ul>
            </div>
          </motion.div>
        </div>

        {/* Bottom Section */}
        <motion.div
          className="border-t border-brand-yellow/30 mt-12 pt-8 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <p className="text-brand-white">
            &copy; 2025 Neev Play School. All rights reserved. | Designed with love for children's growth
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer; 